import Icon from '@mdi/react';
import { Button } from '@nestle-npus-nbm/pds-ui';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Control, useFieldArray } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { mdiAddOutline } from 'src/assets/icons/mdiIcons';
import { DogPets, OfferFormTypes } from '../utils/offer';
import { ProfileFormTypes } from '../utils/profile';
import ControlledPets from './ControlledPets';

const PetCountSection: React.FC<{
  control: Control<any>;
  hideAsterisk?: boolean;
  includeSize?: boolean;
  includeGender?: boolean;
}> = ({ control, includeGender, hideAsterisk = true, includeSize }) => {
  const { t } = useTranslation();
  const {
    fields: catFields,
    append: appendCat,
    remove: removeCat,
  } = useFieldArray<ProfileFormTypes | OfferFormTypes>({
    control,
    name: 'catPets',
  });
  const {
    fields: dogFields,
    append: appendDog,
    remove: removeDog,
  } = useFieldArray<ProfileFormTypes | OfferFormTypes>({
    control,
    name: 'dogPets',
  });

  const handleAddPet = (type: 'CAT' | 'DOG') => {
    // TODO: figure out how inferred conditional types in the OfferFormTypes can.
    // be handled here. since in this case this will be true.
    const newPet: ProfileFormTypes['dogPets'][number] | DogPets = {
      petType: {
        keyName: type,
      },
      name: '',
      birthDate: '',
    };
    if (includeGender) (newPet as unknown as DogPets).gender = 'default';
    if (includeSize) (newPet as unknown as DogPets).size = 'default';
    if (type === 'DOG') {
      appendDog(newPet);
    } else {
      appendCat(newPet);
    }
  };
  return (
    <Col xs={12}>
      <div className="pds-rounded pds-border pds-p-4 sm-bt:pds-border-none sm-bt:pds-p-0">
        <fieldset>
          <legend>{t('My Pets')}</legend>
          <Row className="!pds-mb-4.5 pds-gx-3 pds-gy-3 sm-bt:pds-gx-2">
            <Col xs="auto" className="pds-flex pds-flex-wrap pds-gap-4">
              <Button
                type="button"
                buttonStyle="outlined"
                buttonColor="neutral"
                onClick={() => handleAddPet('DOG')}
                className="pds-flex"
              >
                <Icon path={mdiAddOutline} size={1} className="pds-mr-2" /> {t('Add Dog')}
              </Button>
              <Button
                type="button"
                buttonStyle="outlined"
                buttonColor="neutral"
                onClick={() => handleAddPet('CAT')}
                className="pds-flex"
              >
                <Icon path={mdiAddOutline} size={1} className="pds-mr-2" /> {t('Add Cat')}
              </Button>
            </Col>
          </Row>
          <div className="pds-space-y-3">
            <ControlledPets
              hideAsterisk={hideAsterisk}
              includeGender={includeGender}
              includeSize={includeSize}
              fields={dogFields}
              remove={removeDog}
              petType="dog"
              key="dogPets"
            />
          </div>
          <div className="pds-mt-3 pds-space-y-3">
            <ControlledPets
              hideAsterisk={hideAsterisk}
              includeGender={includeGender}
              includeSize={includeSize}
              fields={catFields}
              remove={removeCat}
              petType="cat"
              key="catPets"
            />
          </div>
        </fieldset>
      </div>
    </Col>
  );
};

export default PetCountSection;
